import { IconButton } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { DropDownMenu } from 'components/DropDownMenu/DropDownMenu';
import { DotsThreeIcon } from 'components/Icons';
import style from './PatientMenu.scss';

export type PatientMenuProps = {
  personId: string;
  onDeletePatient?: (id: string) => void;
  hasPatientCreatePermission?: boolean;
};

export const PatientMenu: React.FC<PatientMenuProps> = ({ personId, onDeletePatient, hasPatientCreatePermission = true }) => {
  const navigate = useNavigate();

  const onEditClick = useCallback(() => {
    navigate(`/patients/${personId}/editPatient`);
  }, [personId, navigate]);

  const menuItems = [
    ...(hasPatientCreatePermission
      ? [
          {
            text: 'Edit',
            onClick: onEditClick
          }
        ]
      : []),
    ...(hasPatientCreatePermission
      ? [
          {
            text: 'Deactivate',
            textClassName: style.redText,
            onClick: () => onDeletePatient?.(personId)
          }
        ]
      : [])
  ];

  // Don't render the menu if there are no options
  if (menuItems.length === 0) {
    return null;
  }

  return (
    <DropDownMenu
      customMenuElement={(onMenuClick) => (
        <IconButton onClick={onMenuClick} size="small">
          <DotsThreeIcon />
        </IconButton>
      )}
      menuItems={menuItems}
    />
  );
};
